import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "tokens", "variant", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useId, useImperativeHandle, useRef } from 'react';
import { LayoutGroup } from 'framer-motion';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import useMaskOnScroll from '@segment/utils/useMaskOnScroll';
import { useTabsContext } from '..';
import * as views from './Track.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseTrack = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
      tokens = _ref.tokens,
      extVariant = _ref.variant,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var scrollableContainerRef = useRef(null);
  var id = useId();

  var _useTabsContext = useTabsContext(),
      globalVariant = _useTabsContext.variant;

  var variant = extVariant !== null && extVariant !== void 0 ? extVariant : globalVariant;
  useImperativeHandle(ref, function () {
    return scrollableContainerRef.current;
  });
  var maskOnScroll = useMaskOnScroll({
    wrapper: scrollableContainerRef
  });
  return _jsx(views.Mask, {
    className: className,
    style: {
      WebkitMaskImage: maskOnScroll,
      maskImage: maskOnScroll
    },
    children: _jsx(views.Track, _objectSpread(_objectSpread({}, tokens), {}, {
      variant: variant,
      children: _jsx(views.Container, _objectSpread(_objectSpread({
        variant: variant,
        ref: scrollableContainerRef,
        "data-testid": "Track[container]"
      }, rest), {}, {
        children: _jsx(LayoutGroup, {
          id: id,
          children: children
        })
      }))
    }))
  });
});
export var Track = withDesignTokens(BaseTrack, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var extVariant = _ref2.variant;

    var _useTabsContext2 = useTabsContext(),
        globalVariant = _useTabsContext2.variant;

    var variant = extVariant !== null && extVariant !== void 0 ? extVariant : globalVariant;
    return {
      backgroundColor: variant === "lined" ? theme.palette.brand.boysenberry[200] : theme.palette.brand.boysenberry[100]
    };
  },
  twilioLight: function twilioLight(theme, _ref3) {
    var extVariant = _ref3.variant;

    var _useTabsContext3 = useTabsContext(),
        globalVariant = _useTabsContext3.variant;

    var variant = extVariant !== null && extVariant !== void 0 ? extVariant : globalVariant;
    return {
      backgroundColor: variant === "lined" ? theme.palette.twilio.gray[20] : theme.palette.twilio.blue[10]
    };
  }
});
export default Track;